import * as t from 'io-ts';
import { timestampCodec } from '../../validation/codecs';
import { mixed, required } from '../../validation/validator';
import { CallResponseMixinSchema, CallResponseSchema } from '../common/callResponseSchema';
import { UserRecordSchema } from '../users/userSchemas';
import { AccountRecordSchema } from './accountSchemas';

// Invite Record Schema
export const InviteRecordSchema = t.type({
    id: t.number,
    account_id: t.number,
    sender_user_id: t.number,
    recipient_user_id: t.union([t.number, t.null]),
    email: t.string,
    sent_at: timestampCodec,
    expires_at: timestampCodec,
    state: t.union([t.literal('pending'), t.literal('accepted'), t.literal('declined')]),
    role_id: t.union([t.number, t.null]),
    created_at: timestampCodec,
    updated_at: timestampCodec
});
export type InviteRecord = t.TypeOf<typeof InviteRecordSchema>;

// Invite Response Schema (includes sender and recipient details)
export const InviteResponseSchema = t.intersection([
    InviteRecordSchema,
    t.partial({
        sender: UserRecordSchema,
        recipient: UserRecordSchema,
        account: AccountRecordSchema
    })
]);
export type InviteResponse = t.TypeOf<typeof InviteResponseSchema>;

// Single Invite Request Schema
export const CreateInviteItemSchema = t.intersection([
    t.type({
        email: t.string,
        role_id: t.number
    }),
    t.partial({
        recipient_user_id: t.number
    })
]);
export type CreateInviteItem = t.TypeOf<typeof CreateInviteItemSchema>;

// Create Invites Schema (Bulk)
export const CreateInvitesSchema = t.type({
    account_id: t.number,
    invites: t.array(CreateInviteItemSchema)
});
export type CreateInvitesRequest = t.TypeOf<typeof CreateInvitesSchema>;

// Get Invites For Account Schema
export const GetInvitesForAccountSchema = t.type({
    account_id: t.number
});

// Get Invites For User Schema
export const GetInvitesForUserSchema = t.partial({
    user_id: t.number,
    email: t.string
});

// Consume Invite Schema
export const ConsumeInviteSchema = t.type({
    invite_id: t.number,
    action: t.union([t.literal('ACCEPT'), t.literal('DECLINE')])
});

// Delete Invite Schema
export const DeleteInviteSchema = t.type({
    invite_id: t.number
});

// API Definitions
export const InviteApis = {
    Invites: {
        CreateInvites: {
            Name: 'account-invites-createInvites',
            Request: CreateInvitesSchema,
            Response: mixed([required({ data: t.array(InviteResponseSchema) }), CallResponseMixinSchema])
        },
        GetInvitesForAccount: {
            Name: 'account-invites-getInvitesForAccount',
            Request: GetInvitesForAccountSchema,
            Response: mixed([required({ data: t.array(InviteResponseSchema) }), CallResponseMixinSchema])
        },
        GetInvitesForUser: {
            Name: 'account-invites-getInvitesForUser',
            Request: GetInvitesForUserSchema,
            Response: mixed([required({ data: t.array(InviteResponseSchema) }), CallResponseMixinSchema])
        },
        ConsumeInvite: {
            Name: 'account-invites-consumeInvite',
            Request: ConsumeInviteSchema,
            Response: CallResponseSchema
        },
        DeleteInvite: {
            Name: 'account-invites-deleteInvite',
            Request: DeleteInviteSchema,
            Response: CallResponseSchema
        }
    }
}; 